document.querySelectorAll('.wpIframe-show-after-load').forEach(function (iframe) {
    iframe.addEventListener('load', function () {
        iframe.style.opacity = 1;
    });
});